export default "__VITE_ASSET__CDqyyZMy__"